import React from 'react';
import IRanking from '@/models/viewModels/IRanking';
import css from 'styled-jsx/css';
import moduleStyles from './ranking.module.scss';

type Props = {
  rankings: IRanking[];
  brandColour: string;
};

function getStyles(primaryColour: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .brand-colour {
      color: ${primaryColour};
    }
  `;
}

export function UniversityRankingItem({ ranking, brandColour }) {
  const { className, styles } = getStyles(brandColour);

  return (
    <>
      {styles}
      <div
        className={`${className} brand-colour border-start-0 border-end-0 border-bottom-0 text-center rounded-border-6 bg-white element-default-style ${
          moduleStyles[`ranking-item`]
        }`}
      >
        <span className={`mb-2 ${moduleStyles.rank}`}>{ranking.rank}</span>
        <span className={moduleStyles[`rank-description`]}>
          {ranking.source} {ranking.year}
        </span>
      </div>
    </>
  );
}

export default function UniversityRanking({ rankings, brandColour }: Props) {
  return (
    <section className={`mt-3 ${moduleStyles.ranking}`} id="university-ranking">
      {rankings?.length &&
        rankings.map((ranking) => (
          <UniversityRankingItem key={ranking.id} ranking={ranking} brandColour={brandColour} />
        ))}
    </section>
  );
}
